<kendo-grid
  *ngIf="reportData"
  [kendoGridBinding]="reportData.rows"
  [pageSize]="25"
  [pageable]="true"
  [height]="725"
>
  <ng-template kendoGridToolbarTemplate>
    <button
      type="button"
      class="excelbtn"
      kendoGridExcelCommand
      icon="file-excel"
    >
      Export to Excel
    </button>
  </ng-template>
  <kendo-grid-column
    [width]="100"
    *ngFor="let columnName of reportData.columnNames"
    [field]="columnName"
    [title]="columnName"
  ></kendo-grid-column>
  <kendo-grid-excel
    fileName="export.xlsx"
    [fetchData]="allData"
  ></kendo-grid-excel>
</kendo-grid>
